<template>
    <el-row align="center" class="body_content" v-if="!disabled" v-loading="loading">

        <el-row class="row title_wrapper">
            <el-button @click="backToPrePage" class="back_button"><i class="el-icon el-icon-arrow-left"></i></el-button>
            <label class="reset_password_title">{{$t('resetPassword.resetPasswordTitle')}}</label>
        </el-row>

        <h4 class="reset_password_description">
            {{$t("resetPassword.resetPasswordDescription")}}
        </h4>

        <div style="margin-top: 20px">
            <el-form :model="form"
                     :rules="rules"
                     class="flex-1 register-form customize-label-top-form"
                     ref="registerForm"
                     @submit.prevent.native="sendConfirmToEmail">
                <el-form-item :label="$t('resetPassword.emailAddressTitle')" prop="email" style="font-weight: bold">
                    <el-input :placeholder="$t('resetPassword.emailAddressPlaceholder')"
                              @change="checkDisableConfirmButton"
                              aria-autocomplete="none"
                              autocomplete="disabled"
                              ref="email"
                              type="text"
                              v-model="form.email"></el-input>
                    <p style="color: red; margin-top: -10px; margin-bottom: 0px" v-show="">
                        {{$t("common.requiredMessage")}}</p>
                </el-form-item>
            </el-form>
        </div>

        <div>
            <el-row class="confirm_button_wrapper">
                <el-button :disabled="disabledConfirmButton" @click="sendConfirmToEmail" class="confirm_button"
                           type="primary">
                    {{$t("resetPassword.confirmButton")}}
                </el-button>
            </el-row>

            <el-row class="bottom_back_button_wrapper">
                <el-button @click="backToPrePage" class="bottom_back_button">{{$t("resetPassword.backButton")}}
                </el-button>
            </el-row>
        </div>

    </el-row>
</template>

<script>

    import UserAPI from "../../../api/user/UserApi";
    import AlertService from "../../../service/alert.service";
    /*Line 96: Send confirm email to reset password success then show confirm screen event*/
    export default {
        name: "EnterEmailAddress",
        data() {
            return {
                rules: {
                    email: [
                        {required: true, message: this.$t("common.requiredMessage"), trigger: ['blur', 'change']},
                        {type: "email", message: this.$t('register.pleaseEnterExactlyFormatEmail'), trigger: ['blur', 'change']},
                    ],
                },
                email: null,
                disabled: false,
                form: {
                    email: null,
                },
                loading: false,
                disabledConfirmButton: true,
            }
        },
        created() {
            this.disabled = false;
        },
        methods: {
            backToPrePage() {
                this.$router.go(-1)
            },
            setDisable(disabled){
                this.disabled = disabled;
            },
            checkDisableConfirmButton() {
                if (this.form.email == null || this.form.email.trim() === "") {
                    this.disabledConfirmButton = true;
                } else {
                    this.disabledConfirmButton = false;
                }
            },
            sendConfirmToEmail() {
                this.loading = true;
                UserAPI.checkEmailExisting(this.form.email).then(async result => {
                    try{
                        if (result) {
                            const isSend = await UserAPI.sendEmailToConfirmResetPassword(this.form.email)
                            if(isSend) this.$emit('sendConfirmEmailSuccess', this.form.email);
                        } else {
                            AlertService.error(this.$t("resetPassword.userNotExist"), 2000)
                        }
                    }catch (e) {
                        AlertService.error(this.$t("common.serverErrorMessage"), 2000)
                    }finally {
                        this.loading = false;
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .body_content {
        width: 40%;
        margin-left: 30%;
    }

    .title_wrapper {
        margin-top: 50px;
    }

    .back_button:hover {
        background-color: white;
    }

    .back_button {
        border: none;
        margin-left: -20px;
        position: absolute;
        cursor: pointer;
        font-size: 30px;
        font-weight: bold;
        z-index: 1;
    }

    .reset_password_title {
        font-weight: bold;
        font-size: 30px;
        position: relative;
        display: inline-block;
        width: calc(80% - 50px);
        margin: 0 calc(10% + 25px);
        text-align: center;
    }

    .reset_password_description {
        margin-left: 2%;
        text-align: center;
    }

    .confirm_button_wrapper {
        text-align: center;
        width: 100%;
        margin-top: 50px
    }

    .confirm_button {
        width: 60%;
        color: white
    }

    .bottom_back_button_wrapper {
        margin-top: 15px;
        text-align: center;
        width: 100%
    }

    .bottom_back_button {
        width: 60%
    }

    @media only screen and (max-width: 1024px) {
        .body_content {
            width: 100%;
            margin-left: 0%;
            margin-right: 0%
        }
    }

    @media only screen and (max-width: 450px){
        .body_content{
            width: 100%;
            margin-left: 0%;
            margin-right: 0%
        }

        #title_wrapper{
            margin-right: 0%;
            margin-left: 0%
        }

        .back_button {
            width: 10%;
            text-align: left!important;
            float: left;
            font-size: 100%;
        }
    }
</style>